// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Alert Component */
:host,
.ids-alert {
  contain: content;
  color: var(--ids-alert-color-default);
}
:host.success,
:host [color=success],
:host [icon=success],
.ids-alert.success,
.ids-alert [color=success],
.ids-alert [icon=success] {
  color: var(--ids-alert-color-success-default);
}
:host.success.disabled,
:host [color=success].disabled,
:host [icon=success].disabled,
.ids-alert.success.disabled,
.ids-alert [color=success].disabled,
.ids-alert [icon=success].disabled {
  color: var(--ids-alert-color-success-disabled);
}
:host.alert,
:host [color=alert],
:host [icon=alert], :host.warning,
:host [color=warning],
:host [icon=warning],
.ids-alert.alert,
.ids-alert [color=alert],
.ids-alert [icon=alert],
.ids-alert.warning,
.ids-alert [color=warning],
.ids-alert [icon=warning] {
  color: var(--ids-alert-color-warning-default);
}
:host.alert.disabled,
:host [color=alert].disabled,
:host [icon=alert].disabled, :host.warning.disabled,
:host [color=warning].disabled,
:host [icon=warning].disabled,
.ids-alert.alert.disabled,
.ids-alert [color=alert].disabled,
.ids-alert [icon=alert].disabled,
.ids-alert.warning.disabled,
.ids-alert [color=warning].disabled,
.ids-alert [icon=warning].disabled {
  color: var(--ids-alert-color-warning-disabled);
}
:host.caution,
:host [color=caution],
:host [icon=caution],
.ids-alert.caution,
.ids-alert [color=caution],
.ids-alert [icon=caution] {
  color: var(--ids-alert-color-caution-default);
}
:host.caution.disabled,
:host [color=caution].disabled,
:host [icon=caution].disabled,
.ids-alert.caution.disabled,
.ids-alert [color=caution].disabled,
.ids-alert [icon=caution].disabled {
  color: var(--ids-alert-color-caution-disabled);
}
:host.info,
:host [color=info],
:host [icon=info],
.ids-alert.info,
.ids-alert [color=info],
.ids-alert [icon=info] {
  color: var(--ids-alert-color-info-default);
}
:host.info.disabled,
:host [color=info].disabled,
:host [icon=info].disabled,
.ids-alert.info.disabled,
.ids-alert [color=info].disabled,
.ids-alert [icon=info].disabled {
  color: var(--ids-alert-color-info-disabled);
}
:host.error,
:host [color=error],
:host [icon=error],
.ids-alert.error,
.ids-alert [color=error],
.ids-alert [icon=error] {
  color: var(--ids-alert-color-error-default);
}
:host.error.disabled,
:host [color=error].disabled,
:host [icon=error].disabled,
.ids-alert.error.disabled,
.ids-alert [color=error].disabled,
.ids-alert [icon=error].disabled {
  color: var(--ids-alert-color-error-disabled);
}
:host.new,
:host [color=new],
:host [icon=new],
.ids-alert.new,
.ids-alert [color=new],
.ids-alert [icon=new] {
  color: var(--ids-alert-color-new-default);
}
:host.new.disabled,
:host [color=new].disabled,
:host [icon=new].disabled,
.ids-alert.new.disabled,
.ids-alert [color=new].disabled,
.ids-alert [icon=new].disabled {
  color: var(--ids-alert-color-new-disabled);
}
:host.in-progress,
:host [color=purple],
:host [icon=in-progress],
.ids-alert.in-progress,
.ids-alert [color=purple],
.ids-alert [icon=in-progress] {
  color: var(--ids-alert-color-progress-default);
}
:host.in-progress.disabled,
:host [color=purple].disabled,
:host [icon=in-progress].disabled,
.ids-alert.in-progress.disabled,
.ids-alert [color=purple].disabled,
.ids-alert [icon=in-progress].disabled {
  color: var(--ids-alert-color-progress-disabled);
}
:host .custom-disabled,
.ids-alert .custom-disabled {
  opacity: var(--ids-opacity-disabled);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-alert/ids-alert.scss"],"names":[],"mappings":"AAAA,wBAAA;AACA;;EAEE,gBAAA;EACA,qCAAA;AACF;AACE;;;;;;EAGE,6CAAA;AAIJ;AAFI;;;;;;EACE,8CAAA;AASN;AALE;;;;;;;;;;;EAME,6CAAA;AAYJ;AAVI;;;;;;;;;;;EACE,8CAAA;AAsBN;AAlBE;;;;;;EAGE,6CAAA;AAuBJ;AArBI;;;;;;EACE,8CAAA;AA4BN;AAvBE;;;;;;EAGE,0CAAA;AA4BJ;AA1BI;;;;;;EACE,2CAAA;AAiCN;AA7BE;;;;;;EAGE,2CAAA;AAkCJ;AAhCI;;;;;;EACE,4CAAA;AAuCN;AAnCE;;;;;;EAGE,yCAAA;AAwCJ;AAtCI;;;;;;EACE,0CAAA;AA6CN;AAzCE;;;;;;EAGE,8CAAA;AA8CJ;AA5CI;;;;;;EACE,+CAAA;AAmDN;AA/CE;;EACE,oCAAA;AAkDJ","sourcesContent":["/* Ids Alert Component */\n:host,\n.ids-alert {\n  contain: content;\n  color: var(--ids-alert-color-default);\n\n  &.success,\n  [color='success'],\n  [icon='success'] {\n    color: var(--ids-alert-color-success-default);\n\n    &.disabled {\n      color: var(--ids-alert-color-success-disabled);\n    }\n  }\n\n  &.alert,\n  [color='alert'],\n  [icon='alert'],\n  &.warning,\n  [color='warning'],\n  [icon='warning'] {\n    color: var(--ids-alert-color-warning-default);\n\n    &.disabled {\n      color: var(--ids-alert-color-warning-disabled);\n    }\n  }\n\n  &.caution,\n  [color='caution'],\n  [icon='caution'] {\n    color: var(--ids-alert-color-caution-default);\n\n    &.disabled {\n      color: var(--ids-alert-color-caution-disabled);\n    }\n  }\n\n\n  &.info,\n  [color='info'],\n  [icon='info'] {\n    color: var(--ids-alert-color-info-default);\n\n    &.disabled {\n      color: var(--ids-alert-color-info-disabled);\n    }\n  }\n\n  &.error,\n  [color='error'],\n  [icon='error'] {\n    color: var(--ids-alert-color-error-default);\n\n    &.disabled {\n      color: var(--ids-alert-color-error-disabled);\n    }\n  }\n\n  &.new,\n  [color='new'],\n  [icon='new'] {\n    color: var(--ids-alert-color-new-default);\n\n    &.disabled {\n      color: var(--ids-alert-color-new-disabled);\n    }\n  }\n\n  &.in-progress,\n  [color='purple'],\n  [icon='in-progress'] {\n    color: var(--ids-alert-color-progress-default);\n\n    &.disabled {\n      color: var(--ids-alert-color-progress-disabled);\n    }\n  }\n\n  .custom-disabled{\n    opacity: var(--ids-opacity-disabled);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
